"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var OPEN_BUTTON_HIDE_CLASS = 'sw-Accordion_OpenButton-hide';
var CLOSE_BUTTON_HIDE_CLASS = 'sw-Accordion_CloseButton-hide';
var OPEN_BUTTON_LOADING_CLASS = 'coSummaryStore-MoreButton-loading';
var LOADING_TEXT = '読み込み中...';
var StoreAccordionController = /** @class */ (function (_super) {
    __extends(StoreAccordionController, _super);
    function StoreAccordionController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loaded = false;
        _this.loading = false;
        _this.isOpen = false;
        _this.openButtonLabel = '';
        _this.open = function () {
            if (!_this.hasContainerTarget || !_this.hasOpenButtonTarget || !_this.hasCloseButtonTarget ||
                !_this.containerTarget || !_this.openButtonTarget || !_this.closeButtonTarget) {
                return;
            }
            if (_this.loading) {
                return;
            }
            _this.isOpen = true;
            if (_this.loaded) {
                _this.showExpanded();
                return;
            }
            _this.startLoadingButton();
            _this.fetchAchievementsReviews();
        };
        _this.close = function () {
            if (!_this.hasContainerTarget || !_this.containerTarget) {
                return;
            }
            _this.isOpen = false;
            _this.containerTarget.style.height = '0px';
            _this.toggleOpenButton(true);
            _this.toggleCloseButton(false);
        };
        _this.fetchAchievementsReviews = function () {
            var url = _this.data.get('achievementsReviewsUrl');
            if (!url || !_this.hasAchievementsReviewsTarget) {
                _this.loaded = true;
                _this.stopLoadingButton();
                if (_this.isOpen) {
                    _this.showExpanded();
                }
                return;
            }
            _this.loading = true;
            fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
                .then(function (response) {
                if (!response.ok) {
                    throw new Error("Request failed: ".concat(response.status));
                }
                return response.text();
            })
                .then(function (html) {
                if (_this.hasAchievementsReviewsTarget && _this.achievementsReviewsTarget) {
                    _this.achievementsReviewsTarget.innerHTML = html;
                }
                _this.loaded = true;
                _this.stopLoadingButton();
                if (_this.isOpen) {
                    _this.showExpanded();
                }
            })
                .catch(function () {
                // loaded stays false so the next open retries the fetch
                _this.stopLoadingButton();
                if (_this.isOpen) {
                    _this.showExpanded();
                }
            })
                .finally(function () {
                _this.loading = false;
            });
        };
        _this.startLoadingButton = function () {
            var _a;
            if (!_this.hasOpenButtonTarget || !_this.openButtonTarget) {
                return;
            }
            if (!_this.openButtonLabel) {
                _this.openButtonLabel = ((_a = _this.openButtonTarget.textContent) !== null && _a !== void 0 ? _a : '').trim();
            }
            _this.openButtonTarget.textContent = LOADING_TEXT;
            _this.openButtonTarget.classList.add(OPEN_BUTTON_LOADING_CLASS);
            _this.openButtonTarget.setAttribute('aria-disabled', 'true');
        };
        _this.stopLoadingButton = function () {
            if (!_this.hasOpenButtonTarget || !_this.openButtonTarget) {
                return;
            }
            if (_this.openButtonLabel) {
                _this.openButtonTarget.textContent = _this.openButtonLabel;
            }
            _this.openButtonTarget.classList.remove(OPEN_BUTTON_LOADING_CLASS);
            _this.openButtonTarget.setAttribute('aria-disabled', 'false');
        };
        _this.showExpanded = function () {
            if (!_this.hasContainerTarget || !_this.containerTarget) {
                return;
            }
            _this.containerTarget.style.height = "".concat(_this.containerTarget.scrollHeight, "px");
            _this.toggleOpenButton(false);
            _this.toggleCloseButton(true);
        };
        _this.toggleOpenButton = function (visible) {
            if (!_this.hasOpenButtonTarget || !_this.openButtonTarget) {
                return;
            }
            _this.openButtonTarget.classList.toggle(OPEN_BUTTON_HIDE_CLASS, !visible);
        };
        _this.toggleCloseButton = function (visible) {
            if (!_this.hasCloseButtonTarget || !_this.closeButtonTarget) {
                return;
            }
            _this.closeButtonTarget.classList.toggle(CLOSE_BUTTON_HIDE_CLASS, !visible);
        };
        return _this;
    }
    StoreAccordionController.targets = ['container', 'openButton', 'closeButton', 'achievementsReviews'];
    return StoreAccordionController;
}(stimulus_1.Controller));
exports.default = StoreAccordionController;
